import { useMemo } from 'react'
import styled from 'styled-components/macro'
import { prop } from 'styled-tools'

const Container = styled.div<{ thickness: number }>`
    position: relative;
    width: 100%;
    height: ${prop('thickness')}px;

    overflow: hidden;
    border-radius: ${({ thickness }) => thickness / 2}px;
    background: #ccc;
`

const Bar = styled.div<{ background: string; thickness: number }>`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${({ thickness }) => thickness / 2}px;

    transition: transform 0.5s;
    transition-timing-function: ease-out;
    background: ${prop('background')};
`

interface CustomLinearProgressProps {
    value: number | number[]
    color?: string | string[]
    thickness?: number
}

export function CustomLinearProgress({ value, color = '#000', thickness = 8 }: CustomLinearProgressProps) {
    const values = useMemo(() => {
        const values = Array.isArray(value) ? value : [value]
        return values.map((v, i) => ({ value: v, index: i })).sort((a, b) => b.value - a.value)
    }, [value])

    const normalizedThickness = Math.max(thickness, 4)

    return (
        <Container thickness={normalizedThickness}>
            {values.map((v, i) => (
                <Bar
                    key={i}
                    thickness={normalizedThickness}
                    style={{ transform: `translateX(-${100 - v.value}%)` }}
                    background={Array.isArray(color) ? color[v.index] : color}
                />
            ))}
        </Container>
    )
}
